var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home_page"},[_c('div',{staticClass:"home_carousel"},[_c('el-carousel',{attrs:{"interval":5000,"arrow":"always"}},[_c('el-carousel-item',[_c('span',{staticClass:"wheatCarouselItem"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"wheat_content"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a946c146","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wheatSchool.vue
// module id = null
// module chunks = 